module.exports = __webpack_public_path__ + "img/08.3635bf42.jpg";